/***
 * Created on 2023/7/11
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

export async function apiGet(endpoint) {
    const response = await fetch(endpoint);
    if (response?.headers?.get('Content-Type').includes('application/json')) {
        const result = await response.json();
        if (!response.ok) {
            const err = new Error('Api Request Error');
            err.cause = result;
            throw err;
        }
        return result;
    }
    else {
        return response;
    }
}

export async function apiPost(endpoint, data, data_type='json', options={}) {
    return await _apiRequest(endpoint, data, data_type);
}

export async function apiPut(endpoint, data, data_type='json', options={}) {
    return await _apiRequest(endpoint, data, data_type, 'PUT');
}

export async function apiDelete(endpoint, data, data_type='json', options={}) {
    return await _apiRequest(endpoint, data, data_type, 'DELETE');
}

async function _apiRequest(endpoint, data, data_type='json', method='POST', options={}) {
    const opts = {
        method
    }

    let csrf_token = options?.csrf_token;
    if (!csrf_token) {
        csrf_token = await getCSRFToken();
    }
    let content_type;
    let body;
    if (data_type !== 'form-data') {
        if (data_type === 'json') {
            content_type = "application/json";
            body = JSON.stringify(data || {});
        }
        else {
            content_type = "application/x-www-form-urlencoded";
            body = new URLSearchParams(data);
        }
        if (content_type) {
            opts.headers = {
                "Content-Type": content_type,
                "X-XSRF-TOKEN": csrf_token
            }
        }
    }
    opts.body = body || data;
    const response = await fetch(endpoint, opts);
    if (response?.headers?.get('Content-Type').includes('application/json')) {
        const result = await response.json();
        if (!response.ok) {
            const err = new Error('Api Request Error');
            err.cause = result;
            throw err;
        }
        return result;
    } else {
        return response;
    }
}

export async function getCSRFToken() {
    try {
        const response = await fetch('/alive');
        if (!response.ok) {
            throw new Error('Api Request Error', {
                cause: response
            });
        }
        return response.headers.get('x-xsrf-token');
    } catch (err) {
        if (err?.cause) {
            console.log(err.cause);
        }
        throw new Error(err);
    }

}

export async function executeGrecaptcha(action, callback, errorCallback=null) {
    const site_key = window.acc_mf.auth.G_RECAPTCHA.SITE_KEY;
    // Make sure recaptcha enterprise.js is loaded
    grecaptcha.enterprise.ready( async function() {
        try {
            const result = await grecaptcha.enterprise.execute(site_key, {action});
            await callback(result);
        } catch (error) {
            console.error("Google reCaptcha error", error)
            if (error === null) {
                await executeGrecaptcha(action, callback, errorCallback);
            }
            else {
                if (typeof errorCallback === 'function') {
                    await errorCallback(error);
                }
            }
        }
    });
}